






























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class EmploymentElement extends Vue {
  @Prop() private company!: string;
  @Prop() private companyPosition!: string;
  @Prop() private startTime!: string;
  @Prop() private endTime!: string;
  @Prop() private description!: string;
  @Prop({
    default: () => {
      return [];
    },
  })
  private accolades!: string[];
  @Prop({
    default: () => {
      return [];
    },
  })
  private responsibilities!: string[];

  get deets() {
    if (this.accolades !== undefined || this.responsibilities !== undefined) {
      return this.accolades.length !== 0 || this.responsibilities.length !== 0;
    }
  }
}
